
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 11.5c0 3.825-2.212 7.75-6.575 11.675a39.289 39.289 0 01-6.438 4.7 1.012 1.012 0 01-.974 0c-.4-.225-7.55-4.288-11.076-10.113A.5.5 0 015.362 17H9.5a.987.987 0 00.838-.45L11.5 14.8l3.162 4.75a1.013 1.013 0 001.15.4 1.1 1.1 0 00.538-.412L18.038 17h2.424a1.025 1.025 0 001.038-.938 1 1 0 00-1-1.062h-3a.987.987 0 00-.837.45L15.5 17.2l-3.162-4.75a1.013 1.013 0 00-1.15-.4 1.1 1.1 0 00-.538.412L8.962 15H3.976a.5.5 0 01-.475-.35A10.775 10.775 0 013 11.5 7.5 7.5 0 0116.5 7 7.5 7.5 0 0130 11.5z","fill":"currentColor"}})])
          )
        }
      }
    